import { MODULE_CONFIG } from "../../config/setup"

const states = {
  contacts_details: {
    contacts: [],
    totalContacts: 0,
    currentPage: 1,
    pageSize: MODULE_CONFIG.CONTACTS.CONTACTS_PER_PAGE_TABLE_DATA,
    loading: false,
    loadError: false,
    selectedContactDetails: [],
    cLoading: false,
    cLoadError: false,
    cPageSize: 10,
    cTotalContacts: 0,
    cCurrentPage: 1,
    pollingIds: [],
  },
}

export default states
